import type { ReactElement } from 'react'

import { trpcMessage } from '../../lib/trpcMessages'
import { Button } from '../Button/Button'
import styles from './errorState.module.scss'

export type ErrorStateProps = {
  /** The query's or mutation's error. Its tRPC code picks the Spanish copy. */
  error?: unknown
  /** Overrides the copy derived from `error`, for a failure of our own making. */
  message?: string
  /** Wire it to `query.refetch()` and the operator can retry without a reload. */
  onRetry?: () => void
}

/**
 * A failed request, on screen, in Spanish. Every query and mutation of the SPA
 * ends up here when it fails: a request that fails silently leaves an empty
 * table, and an empty table is indistinguishable from "there is no work".
 *
 * `role="alert"` so a screen reader announces it, and so a spec can find it
 * without knowing the copy.
 */
export const ErrorState = ({ error, message, onRetry }: ErrorStateProps): ReactElement => (
  <div className={styles['error-state']} role="alert">
    <p className={styles['error-state__message']}>{message ?? trpcMessage(error)}</p>
    {onRetry !== undefined && (
      <Button variant="secondary" onClick={onRetry} label="Reintentar" />
    )}
  </div>
)
